/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const RegisterDeviceBody = zod.object({
  app: zod
    .enum(['onearly', 'strongermemory'])
    .optional()
    .describe(
      "The app the token was minted for. Pushes about a group reach only the tokens of that group's app; every other push reaches the OnEarly app's. Defaults to `onearly`, so existing clients need not send it.",
    ),
  platform: zod.enum(['ios', 'android', 'web']).describe('Device platform the token belongs to'),
  token: zod.string().min(1).describe('Opaque push provider device token (e.g. FCM token)'),
});

export type RegisterDeviceBody = zod.input<typeof RegisterDeviceBody>;
export type RegisterDeviceBodyOutput = zod.output<typeof RegisterDeviceBody>;
